import { Appointment } from '@lyrahealth-inc/shared-app-logic/src/models/appointment/Appointment'
import { ClientListClientObject } from '@lyrahealth-inc/shared-app-logic/src/models/client/ClientListClient'
import { ConversationObject } from '@lyrahealth-inc/shared-app-logic/src/models/conversation/Conversation'

export const isProviderConversation = (conversation: ConversationObject, providerId: string): boolean =>
  conversation.provider_lyra_id === providerId

export const isProviderAppointment = (appointment: Appointment, providerId: string): boolean =>
  appointment.lyraProviderId === providerId

export const mergeClientsById = (
  ...clientGroups: Array<ClientListClientObject[] | undefined>
): ClientListClientObject[] => {
  const clientsById = new Map<string, ClientListClientObject>()
  clientGroups.forEach((clients) =>
    clients?.forEach((client) => {
      if (!clientsById.has(client.id)) {
        clientsById.set(client.id, client)
      }
    }),
  )
  return [...clientsById.values()]
}
